import VuePortal from '@linusborg/vue-simple-portal'
import Vue from 'vue'

Vue.use(VuePortal, {
  selector: '#confirm-portal'
})
